// we start with ControlPanel_ as prefix to avoid name collision start with header so we can toggle on off easily

//action types for control panel show / hide header
export const CONTROL_PANEL_TOGGLE_HEADER = "CONTROL_PANEL_TOGGLE_HEADER";
export const CONTROL_PANEL_SHOW_HEADER = "CONTROL_PANEL_SHOW_HEADER";
export const CONTROL_PANEL_HIDE_HEADER = "CONTROL_PANEL_HIDE_HEADER";

